import React from 'react';
import { Share2, Users, TrendingUp, Copy, ExternalLink, Award } from 'lucide-react';
const leaderboard = [{
  name: 'Lagos Digital Hub',
  seats: 450,
  growth: '+12%',
  status: 'Elite'
}, {
  name: 'Accra Tech Partners',
  seats: 320,
  growth: '+8%',
  status: 'Pro'
}, {
  name: 'Nairobi Resellers',
  seats: 210,
  growth: '+15%',
  status: 'Pro'
}, {
  name: 'Abuja Creative',
  seats: 180,
  growth: '+5%',
  status: 'Standard'
}];
export function Affiliates() {
  return <div className="space-y-8 max-w-[1600px] mx-auto" data-id="element-179">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-180">
        <div data-id="element-181">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-182">
            Referral Network
          </h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-183">
            Manage sub-resellers and track affiliate performance.
          </p>
        </div>
        <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-184">
          <Share2 size={18} data-id="element-185" />
          Generate Referral Link
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-186">
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-187">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-188">
            Total Sub-Resellers
          </p>
          <h3 className="text-2xl font-bold text-slate-900" data-id="element-189">24</h3>
          <div className="mt-4 flex items-center gap-2 text-xs font-bold text-emerald-600" data-id="element-190">
            <TrendingUp size={14} data-id="element-191" />
            <span data-id="element-192">+3 this month</span>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-193">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-194">
            Total Network Seats
          </p>
          <h3 className="text-2xl font-bold text-slate-900" data-id="element-195">1,160</h3>
          <div className="mt-4 flex items-center gap-2 text-xs font-bold text-indigo-600" data-id="element-196">
            <Users size={14} data-id="element-197" />
            <span data-id="element-198">Across 4 countries</span>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-199">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-200">
            Network Commission
          </p>
          <h3 className="text-2xl font-bold text-slate-900" data-id="element-201">$2,450.00</h3>
          <div className="mt-4 flex items-center gap-2 text-xs font-bold text-emerald-600" data-id="element-202">
            <TrendingUp size={14} data-id="element-203" />
            <span data-id="element-204">+18.4% growth</span>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-205">
        <div className="p-6 border-b border-gray-100 flex items-center justify-between" data-id="element-206">
          <h3 className="font-bold text-slate-900" data-id="element-207">Sub-Reseller Leaderboard</h3>
          <button className="text-xs font-bold text-indigo-600 hover:underline" data-id="element-208">
            View Full Network
          </button>
        </div>
        <table className="w-full text-left border-collapse" data-id="element-209">
          <thead data-id="element-210">
            <tr className="text-[10px] font-bold uppercase tracking-wider text-gray-400 border-b border-gray-100" data-id="element-211">
              <th className="px-6 py-4" data-id="element-212">Partner Name</th>
              <th className="px-6 py-4" data-id="element-213">Active Seats</th>
              <th className="px-6 py-4" data-id="element-214">Growth</th>
              <th className="px-6 py-4" data-id="element-215">Status</th>
              <th className="px-6 py-4" data-id="element-216"></th>
            </tr>
          </thead>
          <tbody className="text-sm" data-id="element-217">
            {leaderboard.map(partner => <tr key={partner.name} className="hover:bg-gray-50 transition-colors" data-id="element-218">
                <td className="px-6 py-4 font-bold text-slate-900" data-id="element-219">
                  {partner.name}
                </td>
                <td className="px-6 py-4 font-medium text-slate-700" data-id="element-220">
                  {partner.seats}
                </td>
                <td className="px-6 py-4 font-bold text-emerald-600" data-id="element-221">
                  {partner.growth}
                </td>
                <td className="px-6 py-4" data-id="element-222">
                  <span className={`px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${partner.status === 'Elite' ? 'bg-indigo-50 text-indigo-600' : 'bg-gray-50 text-gray-500'}`} data-id="element-223">
                    {partner.status}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-224">
                  <button className="p-2 text-gray-400 hover:text-indigo-600 transition-colors" data-id="element-225">
                    <ExternalLink size={16} data-id="element-226" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}